export const CONTACT_PHONE = 'Telefon kontaktowy'
export const SERVICE_PHONE = 'Telefon do zgłaszania awarii'
export const EMAIL = 'E-mail'
